import { createFileRoute, useParams } from '@tanstack/react-router';
import { DetailPage } from '@/features/foodcost/SchedaPage';

export const Route = createFileRoute('/_app/foodcost/scheda/$periodoId')({ component: Detail });

function Detail() {
  const { periodoId } = useParams({ from: '/_app/foodcost/scheda/$periodoId' });
  return <DetailPage periodoId={periodoId} />;
}
